import { Link, useParams } from "react-router-dom";
import green_thumbs_up from "../assets/green_thumbs_up.gif";
import axios from "axios";
import { useEffect } from "react";

function EmailVerificationSuccess() {
  const { token } = useParams();

  useEffect(() => {
    axios.put(`https://verbalvortex-server.onrender.com/auth/verify/${token}`).then((response) => {
      console.log(response.data);
    });
  }, []);

  return (
    <div className="EmailVerificationSuccess">
      <div className="EmailVerificationSuccess__message">
        <div className="EmailVerificationSuccess__image">
          <img src={green_thumbs_up} alt="green thumbs up" />
        </div>
        <h1>EMAIL VERIFICATION SUCCESS</h1>
        <p>
          Thank you for your support. Your email has been verified. You can now
          proceed to Home page.
        </p>
        <Link className="Link " to="/">
          TAKE ME TO LOGIN
        </Link>
      </div>
    </div>
  );
}

export default EmailVerificationSuccess;
